import React, { useState, useContext, useEffect } from "react";
import { NavigationContext } from "navigation-react";
import LoaderAnimation from "./LoaderAnimationLarge";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const EditPatientRegister = ({
  editPatientDataID,
  toggleModalEditPatient,
  setModalSuccessMsg,
  refreshPatientAfterEdit,
}) => {
  // eslint-disable-next-line no-unused-vars
  const { data, stateNavigator } = useContext(NavigationContext);

  useEffect(() => {
    console.log("editPatientDataID NID??????????", editPatientDataID.nid);
  }, [editPatientDataID]);

  const [loading, setLoading] = useState(false);
  const [patientfullname, setpatientfullname] = useState(
    editPatientDataID.title || ""
  );
  const [patientgender, setpatientgender] = useState(
    editPatientDataID.field_gender.toLowerCase() === "male" ||
      editPatientDataID.field_gender.toLowerCase() === "female"
      ? editPatientDataID.field_gender.toLowerCase()
      : ""
  );

  const [patientdateofbirth, setpatientdateofbirth] = useState(() => {
    const dob = editPatientDataID.field_date_of_birth;
    const parsedDate = dob ? new Date(dob) : null;
    if (parsedDate instanceof Date && !isNaN(parsedDate)) {
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const day = String(parsedDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // ⚠️ input[type=date] needs this format
    }
    return "";
  });

  const [patientphonenumber, setpatientphonenumber] = useState(
    editPatientDataID.field_patient_phone_number || ""
  );
  const [patientemail, setpatientemail] = useState(
    editPatientDataID.field_patient_email_address || ""
  );

  const username = ls.get("username");
  const userpw = ls.get("userpw");

  if (loading) {
    return <LoaderAnimation loadingTxt="Editing" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const dataFields = {
        type: [{ target_id: "patient" }], // The machine name of the patient content type
        title: [{ value: patientfullname }],
        field_gender: [{ value: patientgender }],
        field_date_of_birth: [{ value: patientdateofbirth }],
        field_patient_phone_number: [{ value: patientphonenumber }],
        field_patient_email_address: [{ value: patientemail }],
      };

      const response = await fetch(
        `/node/${editPatientDataID.nid}?_format=json`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataFields),
        }
      );

      if (response.ok) {
        setLoading(false);
        toggleModalEditPatient();
        setpatientfullname("");
        setpatientgender("");
        setpatientdateofbirth("");
        setpatientphonenumber("");
        setpatientemail("");
        setModalSuccessMsg(true);
        refreshPatientAfterEdit();
      } else {
        setLoading(false);
        const error = await response.json();
        alert(`Error: ${error}`);
        console.log("Error:", error);
      }
    } catch (error) {
      setLoading(false);
      console.log("Network Error:", error);
    }
  };

  return (
    <div className="edit-patient-register">
      <form onSubmit={handleSubmit} className="patient-form">
        <div className="form-group">
          <label htmlFor="title">Full Name</label>
          <input
            type="text"
            value={patientfullname}
            onChange={(e) => setpatientfullname(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="field_gender">Gender</label>
          <select
            value={patientgender}
            onChange={(e) => setpatientgender(e.target.value)}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="field_date_of_birth">Date of Birth</label>
          <input
            type="date"
            value={patientdateofbirth}
            onChange={(e) => setpatientdateofbirth(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="field_patient_phone_number">Contact Number</label>
          <input
            type="tel"
            value={patientphonenumber}
            onChange={(e) => setpatientphonenumber(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="field_patient_email_address">Email Address</label>
          <input
            type="email"
            placeholder=" Enter patient email address"
            value={patientemail}
            onChange={(e) => setpatientemail(e.target.value)}
            required
          />
        </div>
        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {"Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditPatientRegister;
